 fixed="left"<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><router-link to="/pegawai">Pegawai</router-link></li>
                <li><a href="#">Absensi Pegawai</a></li>
                <li class="active">Absensi Pegawai</li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                      <el-row>
                        <el-col :span="12" class="grid-content">
                          <h4>{{ cari }}</h4>
                        </el-col>
                        <el-col :span="12" class="grid-content">
                          <div class="pull-right">
                              <el-date-picker @change='handleChangeDate' 
                                v-model="value4"
                                type="month"
                                placeholder="Pilih bulan">
                              </el-date-picker>
                              Sort by &nbsp;
                              <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="sort">
                                <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                                </el-option>
                              </el-select>
                              <!-- <el-button type="success" icon="el-icon-plus" @click="addData()">Tambah Data</el-button>                             -->
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal"
                          :data="tableData1"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="Tanggal"
                            prop="tanggal"
                            min-width="100">
                            <template slot-scope="scope">
                              <span>{{ scope.row.tanggal.substr(0,10) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Jam"
                            prop="jam"
                            min-width="100">
                            <template slot-scope="scope">
                              <span>{{ scope.row.jam }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Keterangan"
                            prop="keterangan"
                            min-width="100">
                            <template slot-scope="scope">
                              <span>{{ scope.row.keterangan }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Foto"
                            min-width="100">
                            <template slot-scope="scope">
                              <img :src="scope.row.img_path" class="image" style="width: 100%; height: auto; padding: 5px; cursor: zoom-in;" @click="fotoOnClick(scope.row.nama, scope.row.img_path)" onmouseover="">
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Tambah Level" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd">
                  <el-form :model="form" status-icon :rules="rules" ref="form" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Nama" prop="name">
                      <el-input type="text" v-model="form.name" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmAdd('form')">Simpan</el-button>
                    </span>
                </el-dialog>

                <!-- <el-dialog title="Tambah Wilayah" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd">
                  <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="Name" prop="name">
                      <el-input type="text" v-model="form.name" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="confirmAdd('form')">Submit</el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog> -->

                <el-dialog title="Edit Level" :visible.sync="dialogFormWilEdit" v-loading="loadingModalEdit">
                  <el-form :model="form1" status-icon :rules="rules" ref="form1" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Kode" :label-width="formLabelWidth">
                      <el-input v-model="form1.kode" auto-complete="off" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Nama" prop="name" :label-width="formLabelWidth">
                      <el-input type="text" v-model="form1.name" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilEdit = false">Batal</el-button>
                    <el-button type="primary" @click="confirmEdit1('form1')">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Tambah Area" :visible.sync="dialogFormArea" v-loading="loadingModalArea">
                  <el-form :model="form2" status-icon :rules="rules2" ref="form2" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Wilayah" :label-width="formLabelWidth">
                      <el-input v-model="form2.name" auto-complete="off" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Nama Area" prop="area" :label-width="formLabelWidth">
                      <el-input type="text" v-model="form2.area" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="loadingModalArea = false">Batal</el-button>
                    <el-button type="primary" @click="confirmArea1('form2')">Ya</el-button>
                  </span>
                </el-dialog>


                <el-dialog title="Konfirmasi" :visible.sync="dialogFormLunas" v-loading="loadingModalLunas">
                  <h4>Apakah Anda yakin akan melakukan pelunasan tanggal {{tanggal}}-{{bulan}}-{{tahun}} sebesar Rp {{toMoney(nominal)}} ?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormLunas = false">Batal</el-button>
                    <el-button type="primary" @click="confirmLunas1()">Ya</el-button>
                  </span>
                </el-dialog>



                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel">
                  <h4>Apakah Anda yakin akan me-reject {{ form1.name }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>


                <el-dialog title="Konfirmasi" :visible.sync="dialogFormUbah" v-loading="loadingModalUbah">
                  <h4>Apakah Anda yakin akan melakukan perubahan jenis pengeluaran dari {{ form1.name }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormUbah = false">Batal</el-button>
                    <el-button type="primary" @click="confirmUbah1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormInfo">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>

                <el-dialog :title="title" :visible.sync="dialogDet" v-loading="loadingModalDet">
                  <el-table
                    :data="tableData7"
                    style="width: 100%" responsive>
                    <el-table-column
                      label="Tanggal"
                      prop="tanggal"
                      min-width="200">
                    </el-table-column>
                    <el-table-column
                      label="Total"
                      prop="total"
                      min-width="200" align="right" header-align="right">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Pilihan" align="right" header-align="right" width="150" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="Detail" placement="top-start">
                          <el-button type="primary" size="small" icon="ti-eye"  @click="confirmDet1(scope.row)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-dialog>

                <el-dialog :title="title1" :visible.sync="dialogDet1" v-loading="loadingModalDet1">
                  <el-table
                    :data="tableData8"
                    style="width: 100%" responsive>
                    <el-table-column
                      label="Tanggal"
                      prop="tanggal"
                      min-width="200">
                    </el-table-column>
                    <el-table-column
                      label="Jenis"
                      prop="jenis"
                      min-width="200">
                    </el-table-column>
                    <el-table-column
                      label="Nama Barang"
                      prop="nama_barang"
                      min-width="200">
                    </el-table-column>
                    <el-table-column
                      label="Qty"
                      prop="qty"
                      min-width="200">
                    </el-table-column>
                    <el-table-column
                      label="Unit Price"
                      prop="unit_price"
                      min-width="200" align="right" header-align="right">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.unit_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Total Price"
                      prop="total_price"
                      min-width="200" align="right" header-align="right">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Pilihan" align="right" header-align="right" width="150" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.approve === 'Y'" class="item" effect="dark" content="Reject" placement="top-start">
                          <el-button type="danger" size="small" icon="el-icon-error"  @click="confirmDel(scope.row)"></el-button>
                        </el-tooltip>
                        <!-- <span v-else>DITOLAK</span> -->
                        <el-tooltip class="item" effect="dark" content="Ubah Jenis" placement="top-start">
                          <el-button type="primary" size="small" icon="el-icon-refresh"  @click="confirmUbah(scope.row)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-dialog>

                <el-dialog :title="img_title" :visible.sync="dialogFormFotoLihatVisible" v-loading="loadingModalFotoLihat">
                    <img :src="img_path" class="image" style="width: 100%; height: auto;">
                </el-dialog>

                <!-- <el-dialog title="Loading" size="sm" centered hide-footer hide-header class="modal-info" :no-close-on-backdrop='true' :no-close-on-esc='true' :visible.sync="loadingModal" stye="width: 10%; display: flex; min-height: calc(100vh - 60px); flex-direction: column; justify-content: center; overflow: auto;">
                  <b-container fluid>
                    <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
                  </b-container>
                </el-dialog> -->


                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

    import jsonUrl from '../../../assets/url.json'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    Vue.use(VueResource)

    export default {
      name: 'SimpleTable',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          dialogFormFotoLihatVisible: false,
          img_path: '',
          img_title: '',
          value4: new Date(),
          sort: 'none',
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Tanggal Terendah', key: '+bulan' }, { label: 'Tanggal Tertinggi', key: '-bulan' }],
          tableData: [],
          tableData1: [],
          tableData2: [],
          tableData7: [],
          tableData8: [],
          title: '',
          title1: '',
          tanggal: '',
          nominal: '',
          kode_toko: '',
          total: null,
          page_size: 10,
          current_page: 1,
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormLunas: false,
          dialogFormUbah: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          loadingModalLunas: false,
          loadingModalUbah: false,
          dialogFormInfo: false,
          dialogDet: false,
          loadingModalDet: false,
          dialogDet1: false,
          loadingModalDet1: false,
          bulan: '',
          tahun: '',
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            bulan: '',
            tahun: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: '120px',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama', trigger: 'blur' }
            ]
          },
          jenis: [
            {
              kode: 'OPR',
              nama: 'OPR'
            },
            {
              kode: 'COGS',
              nama: 'COGS'
            }
          ]
        }
      },
      methods: {
        fotoOnClick (nama, path) {
          this.img_path = path
          this.img_title = nama
          this.dialogFormFotoLihatVisible = true
        },
        handleChangeDate: function () {
          this.getData()
        },
        handleFilter: function () {
          var byNama = this.tableData.slice(0)
          if (this.sort === '+bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(a.tanggal).getTime()
              var y = new Date(b.tanggal).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort === '-bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(b.tanggal).getTime()
              var y = new Date(a.tanggal).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort === '+jual') {
            byNama.sort(function (a, b) {
              return a.penjualan - b.penjualan
            })
          } else if (this.sort === '-jual') {
            byNama.sort(function (a, b) {
              return b.penjualan - a.penjualan
            })
          } else if (this.sort === '+setor') {
            byNama.sort(function (a, b) {
              return a.uang_setor - b.uang_setor
            })
          } else if (this.sort === '-setor') {
            byNama.sort(function (a, b) {
              return b.uang_setor - a.uang_setor
            })
          } else if (this.sort === '+cogs') {
            byNama.sort(function (a, b) {
              return a.pengeluaran_cogs - b.pengeluaran_cogs
            })
          } else if (this.sort === '-cogs') {
            byNama.sort(function (a, b) {
              return b.pengeluaran_cogs - a.pengeluaran_cogs
            })
          } else if (this.sort === '+opr') {
            byNama.sort(function (a, b) {
              return a.pengeluaran_opr - b.pengeluaran_opr
            })
          } else if (this.sort === '-opr') {
            byNama.sort(function (a, b) {
              return b.pengeluaran_opr - a.pengeluaran_opr
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        toMoney (x) {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        addData: function () {
          this.tableData1.unshift({kode: '', nama: '', edit: true})
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            item.add = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit: function (j, row) {
          this.form1.kode = row.kode
          this.form1.name = row.nama
          // this.dialogFormWilEdit = true
          var item = this.tableData1[j]
          item.edit = true
          item.nama1 = item.nama
          this.$set(this.tableData1, j, item)
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModal = true
              var req = ''
              var action = '/'
              if (row.kode !== '') {
                req = {action: 'update', kode: row.kode, nama: row.nama, jenis: row.jenis}
                action += 'update'
              } else {
                req = {action: 'create', nama: row.nama, jenis: row.jenis}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModal = false
                  this.message = response.body
                  this.dialogFormInfo = true
                  // row.edit = false
                  // row.add = false
                  // this.$set(this.tableData1, j, row)
                  // this.tableData.unshift(row)
                  // this.tableData2 = this.tableData.slice()
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModal = false
              })
            } else {
              return false
            }
          })
        },
        clearForm: function () {
          this.form.kode = ''
          this.form.name = ''
          this.form1.kode = ''
          this.form1.name = ''
          this.form2.kode = ''
          this.form2.name = ''
          this.form2.area = ''
        },
        confirmDet: function (row) {
          this.dialogDet = true
          this.loadingModalDet = true
          this.tableData7 = []

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/detail_bln'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDet = false
              this.title = row.bulan + ' - ' + row.tahun
              this.tableData7 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDet = false
          })
        },
        confirmLunas: function (row) {
          this.dialogFormLunas = true
          this.tanggal = row.tanggal
          this.nominal = row.uang_setor
        },
        confirmLunas1: function () {
          this.loadingModalLunas = true

          var req = {kode_toko: this.kode_toko, bulan: this.bulan, tahun: this.tahun, tanggal: this.tanggal, nominal: this.nominal}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.report_harian + '/setoran'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalLunas = false
              this.dialogFormLunas = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
            }
          }, response => {
            // error callback
            this.loadingModalLunas = false
            this.dialogFormLunas = false
          })
        },
        confirmDet1: function (row) {
          this.dialogDet1 = true
          this.loadingModalDet1 = true
          this.tableData8 = []
          this.form1.tanggal = row.tanggal
          this.form1.bulan = row.bulan
          this.form1.tahun = row.tahun

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun, tanggal: row.tanggal}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/detail_tgl'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDet1 = false
              this.title1 = row.tanggal + ' - ' + row.bulan + ' - ' + row.tahun
              this.tableData8 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDet1 = false
          })
        },
        confirmArea: function (row) {
          this.form2.kode = row.kode
          this.form2.name = row.nama
          this.dialogFormArea = true
        },
        confirmArea1: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // var row = null
              // for (var i = 0; i < this.tableData.length; i++) {
              //   if (this.tableData[i]['kode'] === this.form1.kode) {
              //     row = i
              //   }
              // }
              // this.tableData[row].nama = this.form1.name
              // this.dialogFormWilEdit = false
              this.loadingModalArea = true
              var req = {kode_wilayah: this.form2.kode, nama: this.form2.area}
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.area + '/create'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormArea = false
                  // this.getData()
                  this.loadingModalArea = false
                  this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormArea = false
                this.loadingModalArea = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmAdd: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // var item = []
              // item['kode'] = this.form.kode
              // item['nama'] = this.form.name
              // this.tableData.push(item)var req = {action: 'read'}

              this.loadingModalAdd = true
              var req = {nama: this.form.name}
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/create'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormVisible = false
                  this.loadingModalAdd = false
                  this.getData()
                  this.message = response.body
                  this.dialogFormInfo = true
                  this.clearForm()
                }
              }, response => {
                // error callback
                this.dialogFormVisible = false
                this.loadingModalAdd = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode_toko: this.kode_toko, kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/reject'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              this.confirmDet1(row)
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmUbah: function (row) {
          this.form1.kode = row.kode
          this.form1.name = row.nama_barang
          this.dialogFormUbah = true
        },
        confirmUbah1: function () {
          this.loadingUbah = true
          var req = {kode_toko: this.kode_toko, kode_pengeluaran_harian_item: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/ubah_jenis'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormUbah = false
              this.loadingModalUbah = false
              var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              this.confirmDet1(row)
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormUbah = false
            this.loadingModalUbah = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.bulan = moment(this.value4).format('MM')
          this.tahun = moment(this.value4).format('YYYY')
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = {kode_pegawai: this.kode_toko, tahun: this.tahun, bulan: this.bulan}
          if (this.$route.params.kode !== '+') {
            req = {kode_pegawai: this.$route.params.kode, tahun: this.tahun, bulan: this.bulan}
            this.kode_toko = this.$route.params.kode
            this.cari = this.$route.params.nama
          }
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.absensi + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data.slice()
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        }
      },
      mounted () {
        this.loadingModal = true
        this.getData()
      }
    }
</script>

<style scoped>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>


// WEBPACK FOOTER //
// PegawaiAbsensi.vue?459b4056